import { i18n } from "@/utils/i18n";
const state = {
  category: [
    {
      name: i18n.t("會員賬號"),
      type: 1,
    },
    {
      name: i18n.t("安裝/執行"),
      type: 2,
    },
    {
      name: i18n.t("儲值/購買"),
      type: 3,
    },
    {
      name: i18n.t("遊戲問題"),
      type: 4,
    },
    {
      name: i18n.t("其他"),
      type: 100,
    },
  ],
};
const mutations = {};
const action = {};
export default {
  state,
  mutations,
  action,
};
